module.exports = __webpack_public_path__ + "img/selected0-min.e22ff308.png";